module.exports = __webpack_public_path__ + "img/pointuse.ad5ff6c2.png";